<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/approval_template";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Approval Template",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('approval_templates.singular')) }},
    resourceRoute: {default: 'approval_templates'},
    modelVariable: {default: 'approval_template'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('approval_templates.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('approval_templates.plural')),
          href: "/approval_templates",
        },
        {
          text: this.$t("Create New"),
          href: "/approval_templates/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/approval_templates', value).catch((e) => {
        if (e.response && e.response.data) {
          this.errors = e.response.data.errors;
        }
        throw e
      });
    },
  }
}
</script>
